import { ref } from 'vue'
import { defineStore, storeToRefs } from 'pinia'

const name = 'meta'

const useStore = defineStore(name, () => {
  return {
    websiteUrl: ref(''),
    ogUrl: ref(''),
    ogTitle: ref(''),
    ogDescription: ref(''),
    ogImage: ref('')
  }
})

export function useMeta () {
  const {
    websiteUrl,
    ogUrl, ogTitle,
    ogDescription, ogImage
  } = storeToRefs(useStore())

  return {
    websiteUrl,
    setWebsiteUrl (url) {
      websiteUrl.value = url
    },

    ogUrl,
    setOgUrl (url) {
      ogUrl.value = url
    },

    ogTitle,
    setOgTitle (title) {
      ogTitle.value = title
    },

    ogDescription,
    setOgDescription (description) {
      ogDescription.value = description
    },

    ogImage,
    setOgImage (url) {
      ogImage.value = url
    }
  }
}
